document.querySelectorAll('.eventpage .text-area table, .press-release-list table, .corporatecontentpage .text-area table, .basiccontentpage .text-area table').forEach((table) => {
  const parentEl = table.parentElement
  const tableWrapper = document.createElement('div')
  tableWrapper.classList.add('table-responsive', 'my-3')
  table.classList.add('table', 'w-100')
  parentEl.replaceChild(tableWrapper, table);
  tableWrapper.appendChild(table)
})